module.exports = __webpack_public_path__ + "static/yarn-mrc-205301f2ad98729831f81f829940fe75.jpg";